import { HTTP } from '../../http-common'

export default {
  state: {
    loadedInternetAccessTypes: []
  },
  getters: {
    loadedInternetAccessTypes (state) {
      return state.loadedInternetAccessTypes
    }
  },
  mutations: {
    setLoadedInternetAccessTypes (state, payload) {
      state.loadedInternetAccessTypes = payload
    },
    createInternetAccessType (state, payload) {
      state.loadedInternetAccessTypes.push(payload)
    },
    updateInternetAccessType (state, payload) {
      state.loadedInternetAccessTypes = state.loadedInternetAccessTypes.map(internetAccessType => internetAccessType.id === payload.id ? payload : internetAccessType)
    },
    removeInternetAccessType (state, id) {
      state.loadedInternetAccessTypes = state.loadedInternetAccessTypes.filter(internetAccessType => {
        return internetAccessType.id !== id
      })
    },
    clearLoadedInternetAccessTypes (state) {
      state.loadedInternetAccessTypes = []
    }
  },
  actions: {
    loadInternetAccessTypes ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedInternetAccessTypes', [])

      return new Promise((resolve, reject) => {
        HTTP.get('internet_access_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedInternetAccessTypes', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createInternetAccessType ({ commit, getters }, payload) {
      console.log('createInternetAccessType')
      commit('clearError')
      commit('setLoading', true)
      const newInternetAccessType = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('internet_access_type.json/', newInternetAccessType)
          .then(result => {
            console.log(result)
            commit('createInternetAccessType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateInternetAccessType ({ commit, getters }, payload) {
      console.log('updateInternetAccessType')
      commit('clearError')
      commit('setLoading', true)
      const internetAccessType = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`internet_access_type.json/${payload.id}/`, internetAccessType)
          .then(result => {
            console.log(result)
            commit('updateInternetAccessType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeInternetAccessType ({ commit }, payload) {
      console.log('removeInternetAccessType')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`internet_access_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeInternetAccessType', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedInternetAccessTypes ({ commit }) {
      commit('clearLoadedInternetAccessTypes')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/internet_access_type/index.js